import { render } from "./UserLabelPage.vue?vue&type=template&id=32c1d8a0&ts=true"
import script from "./UserLabelPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLabelPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/user-label/UserLabelPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32c1d8a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32c1d8a0', __exports__)) {
    api.reload('32c1d8a0', __exports__)
  }
  
  module.hot.accept("./UserLabelPage.vue?vue&type=template&id=32c1d8a0&ts=true", () => {
    api.rerender('32c1d8a0', render)
  })

}


export default __exports__